const modalNoBlockZoom = {
  allowPinchZoom: true
}


export {modalNoBlockZoom}
